import { BannerProps } from "@made-people/blueprint-banner";

/**
 * In this file you can specify default props for components that render,
 * which have been wrapped with withManagedProps
 */

export const Banner: BannerProps = {
  // Set to false since we handle preloading of images with link tags
  isMainContent: false,

  settings: {
    image: {
      displaySize: "75vw",
    },
    heading: {
      variants: {
        headingSize: {
          initial: "display-sm",
          lg: "display-lg",
        },
        eyebrowSize: {
          initial: "sm",
          lg: "md",
        },
      },
    },
  },
};
